const messages = {
  title: "Бонус мултипликатор",
  bandBonusTitle: "Бонус на гума при мултипликатора",
  amountLabel: "Мин. брой гуми (*)",
  label: "Бонус мултипликатор",
  desc: "Брой гуми Bridgestone и Firestone. Няма бонус в евро за гуми Firestone.",
  goals: {
    loyal: "Лоялен",
    bronze: "Бронз",
    silver: "Сребро",
    gold: "Злато",
    platinum: "Платина",
  },
  andMore: "и повече",
  chooseTarget: "Изберете",
  selectTarget: "Изберете годишната си цел за {year}:",
  multiplication: "Бонусът се умножава по <b>{factor}</b>",
  minTyres: "<b>Минимум:</b> {tyre} гуми",
};

export default {
  messages,
};
